import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import Utils from './../common/Utils.jsx';

const WorkWrapper = styled.div`
    opacity: 0;
    width: 100%;
`;

export class Work extends Component {

    static propTypes = {}

    state = {
        wrapper_ref: React.createRef()
    };

    componentDidMount() {
        const {wrapper_ref} = this.state;
        Utils.animate(wrapper_ref, 1000, 0, 1, value => {
            wrapper_ref.current.style.opacity = value;
        });
    }

    menu_select = section => {
    }

    render() {
        const {wrapper_ref} = this.state;
        return <WorkWrapper ref={wrapper_ref}>Work</WorkWrapper>
    }
}

export default Work;
